import axios from "axios";

export const GRADE_AND_SECTION_REPORT_URL = "/GradeAndSectionReport";

/** Mevcut Okula Ait Belli Bir Sınıf ve Şube Raporunu Elde Eder */
export function getGradeAndSectionReport(queryParams) {
  return axios.post(`${GRADE_AND_SECTION_REPORT_URL}/GetGradeAndSectionReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Sınıf ve Şube Raporunu Sayfalama Olmadan Elde Eder */
export function getAllGradeAndSectionReport(queryParams) {
  return axios.post(`${GRADE_AND_SECTION_REPORT_URL}/GetAllGradeAndSectionReport`, queryParams);
}